import { useState } from "react";
import '../../styles/EventsStyles/StorageErrorNotice.css';
import { prototypeTools } from "../../webinars/repository";
import { REGISTRATION_CONTACT } from "../../webinars/config";

interface StorageErrorNoticeProps {
  error: unknown;
  /** What couldn't be loaded, e.g. "the webinars" */
  what: string;
}

// Shown when webinar data can't be loaded. In the prototype that means this browser's database,
// which can be rebuilt; in production it's usually the connection, so the visitor can retry.
export default function StorageErrorNotice({ error, what }: StorageErrorNoticeProps) {
  const [resetting, setResetting] = useState(false);
  const tools = prototypeTools;

  if (!tools) {
    return (
      <div className="km-storage-error" role="alert">
        <p><strong>We couldn't load {what}.</strong></p>
        <p>
          Please check your internet connection and try again. If it keeps happening, contact us on{" "}
          {REGISTRATION_CONTACT.phone} or {REGISTRATION_CONTACT.email}.
        </p>
        <button type="button" className="km-btn km-btn--primary" onClick={() => window.location.reload()}>Try again</button>
      </div>
    );
  }

  const detail = error instanceof Error ? `${error.name}: ${error.message}` : String(error);
  const reset = async () => {
    if (!window.confirm("Reset the prototype data in this browser? Registrations and joining links saved in this browser are deleted, and the demonstration webinars are restored.")) return;
    setResetting(true);
    try {
      await tools.deleteLocalDatabase();
    } finally {
      window.location.reload();
    }
  };

  return (
    <div className="km-storage-error" role="alert">
      <p><strong>We couldn't load {what}.</strong></p>
      <p>
        This prototype keeps its data in this browser's storage (IndexedDB), and that storage couldn't be read.
        If you're in a private window, try a normal one. Otherwise, resetting the prototype data usually fixes it.
      </p>
      <p className="km-storage-error-detail">Technical detail: {detail}</p>
      <button type="button" className="km-btn km-btn--primary" onClick={reset} disabled={resetting}>
        {resetting ? "Resetting…" : "Reset prototype data in this browser"}
      </button>
    </div>
  );
}
